// Copyright (C) 2020-2022 Intel Corporation
// Copyright (C) 2023 CVAT.ai Corporation
//
// SPDX-License-Identifier: MIT

import React from 'react';
import { Col } from 'antd/lib/grid';
import Icon from '@ant-design/icons';
import Select from 'antd/lib/select';
import Button from 'antd/lib/button';
import { useSelector } from 'react-redux';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';

import { FilterIcon, FullscreenIcon, InfoIcon } from 'icons';
import { DimensionType } from 'cvat-core-wrapper';
import { CombinedState, Workspace } from 'reducers';
import { updateJobAsync } from 'actions/tasks-actions';
interface Props {
    workspace: Workspace;
    showStatistics(): void;
    showFilters(): void;
    changeWorkspace(workspace: Workspace): void;
    jobInstance: any;
    onDatePick():void
}

function RightGroup(props: Props): JSX.Element {
    const { showStatistics, changeWorkspace, workspace, jobInstance, showFilters, onDatePick } = props;
    const filters = useSelector((state: CombinedState) => state.annotation.annotations.filters);
    const onDateChange = (date: any, dateString: string): void => {
        jobInstance.video_date = date;
        onDatePick();
    };

   

    return (
        <Col className='cvat-annotation-header-right-group'>
            <Button disabled style={{ cursor: 'default', color: 'black' }} className='cvat-annotation-header-button'>
                {jobInstance.phase}
            </Button>
            {jobInstance.phase === 'phase2a' &&
            <Button disabled style={{ cursor: 'default', color: 'black' }} className='cvat-annotation-header-button'>
                V{jobInstance.phase2a_version}
            </Button>}
            {jobInstance.phase === 'phase0' && (
                jobInstance.video_date ? (
                    <DatePicker
                    defaultValue={dayjs(jobInstance.video_date)}
                    onChange={onDateChange}
                    size={'small'}
                    format={'YYYY-MM-DD'}
                    placeholder="Enter Date (Optional)"
                />
                ) : (
                    <DatePicker
                    onChange={onDateChange}
                    size={'small'}
                    format={'YYYY-MM-DD'}
                    placeholder="Enter Date (Optional)"
                />
                )
                
            )}

            <Button
                type='link'
                className='cvat-annotation-header-fullscreen-button cvat-annotation-header-button'
                onClick={(): void => {
                    if (window.document.fullscreenEnabled) {
                        if (window.document.fullscreenElement) {
                            window.document.exitFullscreen();
                        } else {
                            window.document.documentElement.requestFullscreen();
                        }
                    }
                }}
            >
                <Icon component={FullscreenIcon} />
                Fullscreen
            </Button>
            {/* <Button
                type='link'
                className='cvat-annotation-header-info-button cvat-annotation-header-button'
                onClick={showStatistics}
            >
                <Icon component={InfoIcon} />
                Info
            </Button>
            <Button
                type='link'
                className={`cvat-annotation-header-filters-button cvat-annotation-header-button ${filters.length ?
                    'filters-armed' : ''
                }`}
                onClick={showFilters}
            >
                <Icon component={FilterIcon} />
                Filters
            </Button> */}
            <div>
                {/* <Select
                    dropdownClassName='cvat-workspace-selector-dropdown'
                    className='cvat-workspace-selector'
                    onChange={changeWorkspace}
                    value={workspace}
                >
                    {Object.values(Workspace).map((ws) => {
                        if (jobInstance.dimension === DimensionType.DIMENSION_3D) {
                            if (ws === Workspace.STANDARD) {
                                return null;
                            }
                            return (
                                <Select.Option disabled={ws !== Workspace.STANDARD3D} key={ws} value={ws}>
                                    {ws}
                                </Select.Option>
                            );
                        }
                        if (ws !== Workspace.STANDARD3D) {
                            return (
                                <Select.Option key={ws} value={ws}>
                                    {ws}
                                </Select.Option>
                            );
                        }
                        return null;
                    })}
                </Select> */}

            </div>
        </Col>
    );
}

export default React.memo(RightGroup);
